module.exports = __webpack_public_path__ + "img/beautiful-stories.abd940b5.jpg";